<div class="welcome-bg  ui-layout-flex">
    <div class="welcome-div"></div>
</div>